import { RecipeVariants } from '@/style/utils/createRecipeObj';
import { createUseRecipeHook } from '@/style/utils/createUseRecipeHook';
import * as style from './Flex.css';

export const useFlexStyle = createUseRecipeHook(style.root);
export type FlexStyleProps = RecipeVariants<typeof style.root>;
